import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { AnagraficaRubrica, ConfigurazioneAccreditamenti, EventoAccreditamentoSummary, ImpiantoVerifica, Intervento, StatusLevel } from '../../../shared/interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FileUploadComponent } from '../../../common/file-upload/file-upload.component';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

type RubricaDocKey =
  | 'visura_camerale'
  | 'polizza'
  | 'durc'
  | 'abilitazioni'
  | 'preventivo_contratto'
  | 'dvr'
  | 'foglio_intervento'
  | 'scheda_manutenzione';

type AreaMode = 'compagnie' | 'ditte' | 'calendario';
type PickerMode = 'calendar' | 'month' | 'year';
type DitteTab = 'scadenze' | 'verifiche' | 'ditte' | 'interventi';

interface CalDay {
  date: string | null;
  dayNum: number;
  isToday: boolean;
  isCurrentMonth: boolean;
  events: Intervento[];
  scadenze: ImpiantoVerifica[];
  chips: CalChip[];
}

type CalChip =
  | { kind: 'intervento'; item: Intervento }
  | { kind: 'scadenza'; item: ImpiantoVerifica };

@Component({
  selector: 'app-accrediti-backoffice',
  templateUrl: './accrediti-backoffice.component.html',
  styleUrls: ['./accrediti-backoffice.component.css']
})
export class AccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  @ViewChild('deleteSchedaTecnica') deleteSchedaTecnica!: ConfirmPopup;
  @ViewChild('deleteDuvri') deleteDuvri!: ConfirmPopup;
  @ViewChild('uploadSchedaTecnica', { static: false }) uploadSchedaTecnica!: FileUploadComponent;
  @ViewChild('uploadDuvri', { static: false }) uploadDuvri!: FileUploadComponent;

  /** compagnie = Area Compagnie; ditte = lista interventi; calendario = sezione dedicata */
  area: AreaMode = 'compagnie';
  section: 'cruscotto' | 'compagnie' | 'ditte' | 'rubrica' | 'calendario' = 'cruscotto';
  ditteTab: DitteTab = 'scadenze';
  loading = false;

  configurazione?: ConfigurazioneAccreditamenti;
  documenti = false;
  formDocumenti!: FormGroup;

  summaries: EventoAccreditamentoSummary[] = [];
  summaries14: EventoAccreditamentoSummary[] = [];
  scadenze: EventoAccreditamentoSummary[] = [];
  interventiProssimi: Intervento[] = [];
  interventi: Intervento[] = [];
  impianti: ImpiantoVerifica[] = [];
  rubrica: AnagraficaRubrica[] = [];
  rubricaDitte: AnagraficaRubrica[] = [];

  filterPeriod: '14' | '90' | 'stagione' = 'stagione';
  filterState: 'all' | 'crit' | 'ok' = 'all';
  filterSearch = '';
  interventiPeriod: '45' | '90' | 'anno' = 'anno';
  interventiTipo: 'all' | 'ordinario' | 'straordinario' | 'spot' | 'verifica' | 'anomalia' = 'all';
  interventiEsito: 'all' | 'positivo' | 'prescrizioni' | 'negativo' = 'all';
  interventiSearch = '';
  rubricaSearch = '';
  ditteStatoFilter: 'all' | 'accreditata' | 'documenti' | 'da_completare' = 'all';
  impiantiSearch = '';
  impiantiCategoria = '';
  impiantiStatoFilter = '';
  calendarioDayFilter: string | null = null;

  readonly DOW = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
  readonly MONTHS = [
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
    'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
  ];
  calMonth = new Date().getMonth();
  calYear = new Date().getFullYear();
  pickerMode: PickerMode = 'calendar';
  yearRangeStart = new Date().getFullYear() - 4;

  interventoDialog = false;
  interventoEdit?: Intervento;
  formIntervento!: FormGroup;

  impiantoDialog = false;
  impiantoDetailDialog = false;
  impiantoEdit?: ImpiantoVerifica;
  impiantoDetail?: ImpiantoVerifica;
  formImpianto!: FormGroup;
  interventiImpianto: Intervento[] = [];

  rubricaDialog = false;
  rubricaEdit?: AnagraficaRubrica;
  formRubrica!: FormGroup;

  creaEventoDialog = false;
  creaEventoRubrica?: AnagraficaRubrica;
  formCreaEvento!: FormGroup;

  tipiFornitore = [
    { label: 'Compagnia', value: 'compagnia' },
    { label: 'Ditta / fornitore', value: 'ditta' },
  ];
  tipiIntervento = [
    { label: 'Verifica periodica', value: 'verifica' },
    { label: 'Manutenzione ordinaria', value: 'ordinario' },
    { label: 'Manutenzione straordinaria', value: 'straordinario' },
    { label: 'Risoluzione anomalia', value: 'anomalia' },
    { label: 'Spot', value: 'spot' },
  ];
  esitiIntervento = [
    { label: 'Positivo', value: 'positivo' },
    { label: 'Positivo con prescrizioni', value: 'prescrizioni' },
    { label: 'Negativo', value: 'negativo' },
  ];
  statiAccreditamento = [
    { label: 'Da completare', value: 'da_completare' },
    { label: 'In verifica', value: 'in_verifica' },
    { label: 'Accreditata', value: 'accreditata' },
    { label: 'Sospesa', value: 'sospesa' },
  ];
  categorieImpianto = [
    { label: 'Antincendio', value: 'Antincendio' },
    { label: 'Elettrico', value: 'Elettrico' },
    { label: 'Palcoscenico', value: 'Palcoscenico' },
    { label: 'Climatizzazione', value: 'Climatizzazione' },
    { label: 'Organizzazione', value: 'Organizzazione' },
    { label: 'Da completare', value: 'Da completare' },
  ];
  periodicitaImpianto = [
    { label: 'Prima di ogni spettacolo', value: 'prima_spettacolo' },
    { label: 'Bimestrale', value: 'bimestrale' },
    { label: 'Ogni 4 mesi', value: 'ogni_4_mesi' },
    { label: 'Semestrale', value: 'semestrale' },
    { label: 'Annuale', value: 'annuale' },
    { label: 'Biennale', value: 'biennale' },
    { label: 'Decennale', value: 'decennale' },
    { label: 'Da definire', value: 'da_definire' },
  ];
  statiImpianto = [
    { label: 'Da completare', value: 'da_completare' },
    { label: 'Da programmare', value: 'da_programmare' },
    { label: 'Programmata', value: 'programmata' },
    { label: 'Regolare', value: 'regolare' },
    { label: 'Sospesa con motivazione', value: 'sospesa' },
  ];
  preavvisiImpianto = [
    { label: 'Solo 7 giorni prima', value: '7' },
    { label: '30 e 7 giorni prima', value: '30_7' },
    { label: '60, 30 e 7 giorni prima', value: '60_30_7' },
  ];
  categorieFiltro = [{ label: 'Tutte le categorie', value: '' }, ...this.categorieImpianto];
  statiDisplayFiltro = [
    { label: 'Tutti gli stati', value: '' },
    { label: 'Scaduta', value: 'Scaduta' },
    { label: 'In scadenza', value: 'In scadenza' },
    { label: 'Da programmare', value: 'Da programmare' },
    { label: 'Programmato', value: 'Programmato' },
    { label: 'Regolare', value: 'Regolare' },
    { label: 'Da completare', value: 'Da completare' },
  ];
  ricorrenze = [
    { label: 'Settimanale', value: 'settimanale' },
    { label: 'Mensile', value: 'mensile' },
    { label: 'Trimestrale', value: 'trimestrale' },
    { label: 'Semestrale', value: 'semestrale' },
    { label: 'Annuale', value: 'annuale' },
  ];
  stati = [
    { label: 'OK', value: 'ok' },
    { label: 'In attesa', value: 'wait' },
    { label: 'Attenzione', value: 'warn' },
    { label: 'Critico', value: 'crit' },
    { label: 'N/A', value: 'na' },
  ];

  /** Documenti ditta stile mockup (+ legacy compagnia) */
  rubricaDocs: { key: RubricaDocKey; scad: string; label: string }[] = [
    { key: 'visura_camerale', scad: 'visura_scadenza', label: 'Visura camerale' },
    { key: 'durc', scad: 'durc_scadenza', label: 'DURC' },
    { key: 'polizza', scad: 'polizza_scadenza', label: 'Polizza RC' },
    { key: 'abilitazioni', scad: 'abilitazioni_scadenza', label: 'Abilitazioni / certificazioni' },
    { key: 'preventivo_contratto', scad: 'preventivo_contratto_scadenza', label: 'Contratto / incarico' },
    { key: 'dvr', scad: 'dvr_scadenza', label: 'DUVRI / DVR' },
    { key: 'foglio_intervento', scad: 'foglio_intervento_scadenza', label: 'Foglio di intervento' },
    { key: 'scheda_manutenzione', scad: 'scheda_manutenzione_scadenza', label: 'Scheda manutenzione' },
  ];

  get rubricaDocsDitta() {
    return this.rubricaDocs.filter(d =>
      ['visura_camerale', 'durc', 'polizza', 'abilitazioni', 'preventivo_contratto'].includes(d.key)
    );
  }

  get rubricaDocsAttivi() {
    const tipo = this.formRubrica?.get('tipo')?.value || this.rubricaEdit?.tipo || 'ditta';
    return tipo === 'ditta' ? this.rubricaDocsDitta : this.rubricaDocs;
  }

  ngOnInit(): void {
    this.formDocumenti = new FormGroup({
      scheda_tecnica: new FormControl(null),
      duvri: new FormControl(null)
    });
    this.formIntervento = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      id_fornitore: new FormControl(null),
      id_impianto: new FormControl(null),
      tipo: new FormControl('verifica', Validators.required),
      data_ora: new FormControl(null, Validators.required),
      ricorrente: new FormControl(false),
      ricorrenza: new FormControl(null),
      durata_ore: new FormControl(null),
      n_lavoratori: new FormControl(0),
      note_interne: new FormControl(null),
      esito: new FormControl(null),
      prossima_scadenza: new FormControl(null),
      criticita: new FormControl('wait'),
      stato_doc: new FormControl('wait'),
      stato_op: new FormControl('wait'),
      stato_pers: new FormControl('wait'),
      ordine_lavoro: new FormControl(null),
      preventivo: new FormControl(null),
    });
    this.formImpianto = new FormGroup({
      nome: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      categoria: new FormControl('Da completare', Validators.required),
      periodicita: new FormControl('semestrale', Validators.required),
      id_fornitore: new FormControl(null),
      incaricato: new FormControl(null),
      stato: new FormControl('da_programmare', Validators.required),
      ultimo_intervento: new FormControl(null),
      prossima_scadenza: new FormControl(null),
      preavviso: new FormControl('30_7'),
      checklist: new FormControl(null),
      note: new FormControl(null),
      documento: new FormControl(null),
    });
    this.formRubrica = new FormGroup({
      tipo: new FormControl('ditta'),
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null),
      sede: new FormControl(null),
      referente: new FormControl(null),
      email: new FormControl(null),
      telefono: new FormControl(null),
      abituale: new FormControl(false),
      note: new FormControl(null),
      specializzazione: new FormControl(null),
      stato_accreditamento: new FormControl('da_completare'),
      visura_camerale: new FormControl(null),
      visura_scadenza: new FormControl(null),
      polizza: new FormControl(null),
      polizza_scadenza: new FormControl(null),
      durc: new FormControl(null),
      durc_scadenza: new FormControl(null),
      abilitazioni: new FormControl(null),
      abilitazioni_scadenza: new FormControl(null),
      dvr: new FormControl(null),
      dvr_scadenza: new FormControl(null),
      preventivo_contratto: new FormControl(null),
      preventivo_contratto_scadenza: new FormControl(null),
      foglio_intervento: new FormControl(null),
      foglio_intervento_scadenza: new FormControl(null),
      scheda_manutenzione: new FormControl(null),
      scheda_manutenzione_scadenza: new FormControl(null),
    });
    this.formCreaEvento = new FormGroup({
      evento: new FormControl(null, Validators.required),
      dal: new FormControl(null, Validators.required),
      al: new FormControl(null, Validators.required),
    });

    this.formIntervento.get('ricorrente')?.valueChanges.subscribe((v) => {
      const ctrl = this.formIntervento.get('ricorrenza');
      if (v) ctrl?.setValidators(Validators.required);
      else {
        ctrl?.clearValidators();
        ctrl?.setValue(null);
      }
      ctrl?.updateValueAndValidity({ emitEvent: false });
    });

    // Stesso componente su 3 route: reagisci al cambio area
    this.route.data.subscribe((data) => {
      this.area = (data['area'] as AreaMode) || 'compagnie';
      if (this.area === 'ditte') this.section = 'ditte';
      else if (this.area === 'calendario') this.section = 'calendario';
      else this.section = 'cruscotto';
      this.calendarioDayFilter = null;
      this.pickerMode = 'calendar';
      this.reloadAll();
    });
  }

  reloadAll() {
    this.loading = true;
    let range: { dal: string; al: string };
    if (this.area === 'calendario') {
      const last = new Date(this.calYear, this.calMonth + 1, 0).getDate();
      range = {
        dal: `${this.calYear}-${String(this.calMonth + 1).padStart(2, '0')}-01`,
        al: `${this.calYear}-${String(this.calMonth + 1).padStart(2, '0')}-${String(last).padStart(2, '0')} 23:59:59`,
      };
    } else if (this.area === 'ditte') {
      // Storico + prossime: 1 anno indietro / 1 anno avanti
      const now = new Date();
      const dal = new Date(now); dal.setFullYear(dal.getFullYear() - 1);
      const al = new Date(now); al.setFullYear(al.getFullYear() + 1);
      range = { dal: this.toISODate(dal), al: this.toISODate(al) + ' 23:59:59' };
    } else {
      range = this.dateRange(this.interventiPeriod === '45' ? 45 : this.interventiPeriod === '90' ? 90 : 365);
    }
    forkJoin({
      config: this.apiService.getConfigurazioneAccreditamenti().pipe(catchError(() => of(undefined))),
      summaries: this.apiService.getEventiAccreditamentiSummary().pipe(catchError(() => of([]))),
      interventiProssimi: this.apiService.getInterventiProssimi().pipe(catchError(() => of([]))),
      interventi: this.apiService.getInterventi(range.dal, range.al).pipe(catchError(() => of([]))),
      impianti: this.apiService.getImpianti().pipe(catchError(() => of([]))),
      rubrica: this.apiService.getRubrica().pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ config, summaries, interventiProssimi, interventi, impianti, rubrica }) => {
        this.configurazione = config;
        this.summaries = summaries || [];
        this.summaries14 = this.filterByDays(this.summaries, 14);
        this.scadenze = this.summaries.filter(s => s.summary.level === 'crit' || s.summary.level === 'warn').slice(0, 8);
        this.interventiProssimi = interventiProssimi || [];
        this.interventi = interventi || [];
        this.impianti = impianti || [];
        this.rubrica = rubrica || [];
        this.rubricaDitte = this.rubrica.filter(r => r.tipo === 'ditta');
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err?.error?.message || 'Errore di caricamento');
      }
    });
  }

  dateRange(days: number): { dal: string; al: string } {
    const now = new Date();
    const al = new Date(now);
    al.setDate(al.getDate() + days);
    return { dal: this.toISODate(now), al: this.toISODate(al) };
  }

  toISODate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  parseDay(value: string | Date | null | undefined): Date | null {
    if (!value) return null;
    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) return null;
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
    const s = String(value).slice(0, 10);
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (!m) return null;
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }

  filterByDays(list: EventoAccreditamentoSummary[], days: number): EventoAccreditamentoSummary[] {
    const today = this.parseDay(new Date())!;
    const from = new Date(today);
    from.setDate(from.getDate() - days);
    const to = new Date(today);
    to.setDate(to.getDate() + days);
    return list.filter(e => {
      const dal = this.parseDay(e.dal);
      const al = this.parseDay(e.al);
      if (!dal || !al) return false;
      return dal <= to && al >= from;
    });
  }

  get compagnieFiltrate(): EventoAccreditamentoSummary[] {
    let list = [...this.summaries];
    if (this.filterPeriod === '14') list = this.filterByDays(list, 14);
    else if (this.filterPeriod === '90') list = this.filterByDays(list, 90);

    if (this.filterState === 'crit') list = list.filter(e => e.summary.level === 'crit' || e.summary.level === 'warn');
    else if (this.filterState === 'ok') list = list.filter(e => e.summary.level === 'ok');

    const q = this.filterSearch.trim().toLowerCase();
    if (q) {
      list = list.filter(e =>
        (e.evento || '').toLowerCase().includes(q) ||
        (e.ragione_sociale || '').toLowerCase().includes(q)
      );
    }
    return list;
  }

  get interventiFiltrati(): Intervento[] {
    let list = [...this.interventi];
    if (this.interventiTipo !== 'all') list = list.filter(i => i.tipo === this.interventiTipo);
    if (this.interventiEsito !== 'all') list = list.filter(i => i.esito === this.interventiEsito);
    const q = this.interventiSearch.trim().toLowerCase();
    if (q) {
      list = list.filter(i =>
        (i.titolo || '').toLowerCase().includes(q) ||
        (i.fornitore || '').toLowerCase().includes(q) ||
        (i.impianto || '').toLowerCase().includes(q) ||
        (i.fornitore_piva || '').toLowerCase().includes(q) ||
        (i.note_interne || '').toLowerCase().includes(q) ||
        (i.esito || '').toLowerCase().includes(q)
      );
    }
    if (this.calendarioDayFilter && this.area === 'ditte') {
      list = list.filter(i => String(i.data_ora || '').slice(0, 10) === this.calendarioDayFilter);
    }
    return list;
  }

  /** Storico cronologico (più recenti prima). */
  get interventiStorico(): Intervento[] {
    return [...this.interventiFiltrati].sort((a, b) =>
      String(b.data_ora || '').localeCompare(String(a.data_ora || ''))
    );
  }

  get ditteFiltrate(): AnagraficaRubrica[] {
    let list = [...this.rubricaDitte];
    const q = this.rubricaSearch.trim().toLowerCase();
    if (q) {
      list = list.filter(r =>
        (r.ragione_sociale || '').toLowerCase().includes(q) ||
        (r.specializzazione || '').toLowerCase().includes(q) ||
        (r.referente || '').toLowerCase().includes(q) ||
        (r.piva || '').toLowerCase().includes(q)
      );
    }
    if (this.ditteStatoFilter === 'accreditata') {
      list = list.filter(r => (r.stato_accreditamento || 'da_completare') === 'accreditata');
    } else if (this.ditteStatoFilter === 'da_completare') {
      list = list.filter(r => (r.stato_accreditamento || 'da_completare') === 'da_completare');
    } else if (this.ditteStatoFilter === 'documenti') {
      list = list.filter(r => {
        const lvl = this.docScadenzaLevel(r);
        return lvl === 'warn' || lvl === 'crit';
      });
    }
    return list;
  }

  /** Prossime scadenze impianti (+ documenti ditte). */
  get scadenzeManutenzione(): {
    kind: 'impianto' | 'documento';
    title: string;
    note: string;
    date: string;
    level: 'crit' | 'warn' | 'blue' | 'ok';
    label: string;
    impianto?: ImpiantoVerifica;
  }[] {
    const today = this.parseDay(new Date())!;
    const limit = new Date(today);
    limit.setDate(limit.getDate() + 60);
    const out: {
      kind: 'impianto' | 'documento';
      title: string;
      note: string;
      date: string;
      level: 'crit' | 'warn' | 'blue' | 'ok';
      label: string;
      impianto?: ImpiantoVerifica;
    }[] = [];

    for (const imp of this.impianti) {
      const day = this.parseDay(imp.prossima_scadenza);
      if (!day) continue;
      if (day > limit) continue;
      const status = imp.stato_display || this.impiantoStatusLabel(imp);
      const past = day < today;
      const days = Math.round((day.getTime() - today.getTime()) / 86400000);
      let level: 'crit' | 'warn' | 'blue' | 'ok' = 'blue';
      let label = status;
      if (past || status === 'Scaduta') { level = 'crit'; label = 'Scaduta'; }
      else if (status === 'In scadenza' || days <= 14) { level = 'warn'; label = days >= 0 ? `${days} giorni` : status; }
      else if (status === 'Regolare') { level = 'ok'; }
      out.push({
        kind: 'impianto',
        title: imp.nome,
        note: `${this.periodicitaLabel(imp.periodicita)} · ${imp.fornitore || imp.incaricato || 'ditta da confermare'}`,
        date: this.toISODate(day),
        level,
        label,
        impianto: imp,
      });
    }

    for (const row of this.scadenzeDocumentiRubrica) {
      out.push({
        kind: 'documento',
        title: row.doc,
        note: row.anagrafica,
        date: row.data,
        level: row.level,
        label: row.level === 'crit' ? 'Scaduta' : 'In scadenza',
      });
    }

    return out.sort((a, b) => a.date.localeCompare(b.date)).slice(0, 20);
  }

  get impiantiFiltrati(): ImpiantoVerifica[] {
    let list = [...this.impianti];
    const q = this.impiantiSearch.trim().toLowerCase();
    if (q) {
      list = list.filter(i =>
        (i.nome || '').toLowerCase().includes(q) ||
        (i.descrizione || '').toLowerCase().includes(q) ||
        (i.fornitore || '').toLowerCase().includes(q) ||
        (i.incaricato || '').toLowerCase().includes(q) ||
        (i.categoria || '').toLowerCase().includes(q)
      );
    }
    if (this.impiantiCategoria) list = list.filter(i => i.categoria === this.impiantiCategoria);
    if (this.impiantiStatoFilter) {
      list = list.filter(i => (i.stato_display || this.impiantoStatusLabel(i)) === this.impiantiStatoFilter);
    }
    return list;
  }

  get rubricaFiltrata(): AnagraficaRubrica[] {
    let list = [...this.rubrica];
    const q = this.rubricaSearch.trim().toLowerCase();
    if (q) {
      list = list.filter(r =>
        (r.ragione_sociale || '').toLowerCase().includes(q) ||
        (r.piva || '').toLowerCase().includes(q) ||
        (r.referente || '').toLowerCase().includes(q) ||
        (r.telefono || '').toLowerCase().includes(q) ||
        (r.email || '').toLowerCase().includes(q) ||
        (r.tipo || '').toLowerCase().includes(q) ||
        (r.specializzazione || '').toLowerCase().includes(q)
      );
    }
    return list;
  }

  get badgeCrit(): number {
    return this.summaries.filter(s => s.summary.level === 'crit' || s.summary.level === 'warn').length;
  }

  /** Scadenze documenti rubrica entro 30 giorni (o già scaduti). */
  get scadenzeDocumentiRubrica(): { anagrafica: string; doc: string; data: string; level: 'crit' | 'warn' }[] {
    const today = this.parseDay(new Date())!;
    const limit = new Date(today);
    limit.setDate(limit.getDate() + 30);
    const out: { anagrafica: string; doc: string; data: string; level: 'crit' | 'warn' }[] = [];
    for (const a of this.rubrica) {
      for (const d of this.rubricaDocs) {
        const raw = (a as any)[d.scad];
        const day = this.parseDay(raw);
        if (!day) continue;
        if (day > limit) continue;
        const iso = this.toISODate(day);
        out.push({
          anagrafica: a.ragione_sociale,
          doc: d.label,
          data: iso,
          level: day < today ? 'crit' : 'warn',
        });
      }
    }
    return out.sort((x, y) => x.data.localeCompare(y.data)).slice(0, 12);
  }

  setPeriod(p: '14' | '90' | 'stagione') { this.filterPeriod = p; }
  setState(s: 'all' | 'crit' | 'ok') { this.filterState = s; }

  setInterventiPeriod(p: '45' | '90' | 'anno') {
    this.interventiPeriod = p;
    const days = p === '45' ? 45 : p === '90' ? 90 : 365;
    const range = this.dateRange(days);
    this.apiService.getInterventi(range.dal, range.al).subscribe({
      next: (data) => this.interventi = data || [],
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore')
    });
  }

  refreshInterventi() {
    if (this.area === 'calendario') this.loadCalMonth();
    else if (this.area === 'ditte') {
      const now = new Date();
      const dal = new Date(now); dal.setFullYear(dal.getFullYear() - 1);
      const al = new Date(now); al.setFullYear(al.getFullYear() + 1);
      this.apiService.getInterventi(this.toISODate(dal), this.toISODate(al) + ' 23:59:59').subscribe({
        next: (data) => this.interventi = data || [],
        error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore')
      });
      this.apiService.getImpianti().subscribe({ next: (d) => this.impianti = d || [] });
    } else this.setInterventiPeriod(this.interventiPeriod);
    this.apiService.getInterventiProssimi().subscribe({ next: (d) => this.interventiProssimi = d || [] });
  }

  openEvento(id: number) {
    this.router.navigate(['/backoffice/area-compagnie', id]);
  }

  get pageTitle(): string {
    if (this.area === 'ditte') return 'Manutenzioni e verifiche';
    if (this.area === 'calendario') return 'Calendario interventi e scadenze';
    return 'Area Compagnie';
  }

  tipoInterventoLabel(tipo: string | undefined): string {
    return this.tipiIntervento.find(t => t.value === tipo)?.label || tipo || '—';
  }

  esitoLabel(esito: string | null | undefined): string {
    if (!esito) return '—';
    return this.esitiIntervento.find(e => e.value === esito)?.label || esito;
  }

  esitoPillClass(esito: string | null | undefined): string {
    if (esito === 'positivo') return 'ok';
    if (esito === 'prescrizioni') return 'warn';
    if (esito === 'negativo') return 'crit';
    return 'na';
  }

  statoAccLabel(s: string | undefined): string {
    return this.statiAccreditamento.find(x => x.value === (s || 'da_completare'))?.label || 'Da completare';
  }

  statoAccPill(a: AnagraficaRubrica): { cls: string; text: string } {
    const s = a.stato_accreditamento || 'da_completare';
    const doc = this.docScadenzaLevel(a);
    if (doc === 'crit') return { cls: 'crit', text: 'Documenti scaduti' };
    if (doc === 'warn') return { cls: 'warn', text: 'Documenti in scadenza' };
    if (s === 'accreditata') return { cls: 'ok', text: 'Accreditata' };
    if (s === 'in_verifica') return { cls: 'warn', text: 'In verifica' };
    if (s === 'sospesa') return { cls: 'crit', text: 'Sospesa' };
    return { cls: 'outline', text: 'Da completare' };
  }

  dittaDocFoot(a: AnagraficaRubrica): string {
    const lvl = this.docScadenzaLevel(a);
    if (lvl === 'crit') return 'Documenti scaduti';
    if (lvl === 'warn') return 'Scadenza documenti vicina';
    if (lvl === 'ok') return 'Documenti validi';
    return 'Dati incompleti';
  }

  countInterventiDitta(a: AnagraficaRubrica): number {
    return this.interventi.filter(i => i.id_fornitore === a.id).length;
  }

  countImpiantiDitta(a: AnagraficaRubrica): number {
    return this.impianti.filter(i => i.id_fornitore === a.id).length;
  }

  periodicitaLabel(p: string | undefined): string {
    return this.periodicitaImpianto.find(x => x.value === p)?.label || p || '—';
  }

  impiantoStatusLabel(imp: ImpiantoVerifica): string {
    if (imp.stato_display) return imp.stato_display;
    if (imp.stato === 'da_completare') return 'Da completare';
    if (imp.stato === 'sospesa') return 'Sospesa';
    const day = this.parseDay(imp.prossima_scadenza);
    const today = this.parseDay(new Date())!;
    if (!day) {
      if (imp.stato === 'da_programmare') return 'Da programmare';
      if (imp.stato === 'programmata') return 'Programmato';
      return 'Regolare';
    }
    if (day < today) return 'Scaduta';
    const days = Math.round((day.getTime() - today.getTime()) / 86400000);
    if (days <= 30) return 'In scadenza';
    if (imp.stato === 'programmata') return 'Programmato';
    if (imp.stato === 'da_programmare') return 'Da programmare';
    return 'Regolare';
  }

  impiantoStatusClass(status: string | undefined): string {
    switch (status) {
      case 'Scaduta': return 'crit';
      case 'In scadenza':
      case 'Da programmare': return 'warn';
      case 'Programmato': return 'wait';
      case 'Regolare': return 'ok';
      case 'Da completare':
      case 'Sospesa': return 'outline';
      default: return 'na';
    }
  }

  onImpiantoFornitoreChange() {
    const id = this.formImpianto.get('id_fornitore')?.value;
    const ditta = this.rubricaDitte.find(d => d.id === id);
    if (ditta && !this.formImpianto.get('incaricato')?.value) {
      this.formImpianto.get('incaricato')?.setValue(ditta.ragione_sociale);
    }
  }

  onInterventoImpiantoChange() {
    const id = this.formIntervento.get('id_impianto')?.value;
    const imp = this.impianti.find(i => i.id === id);
    if (!imp) return;
    if (!this.formIntervento.get('titolo')?.value) {
      this.formIntervento.get('titolo')?.setValue(imp.nome);
    }
    if (imp.id_fornitore && !this.formIntervento.get('id_fornitore')?.value) {
      this.formIntervento.get('id_fornitore')?.setValue(imp.id_fornitore);
    }
  }

  specializzazioneTags(a: AnagraficaRubrica): string[] {
    return (a.specializzazione || '')
      .split(/[,;/|]+/)
      .map(s => s.trim())
      .filter(Boolean)
      .slice(0, 6);
  }

  setDitteTab(tab: DitteTab) {
    this.ditteTab = tab;
  }

  // —— Calendario (stile scadenziario assets) ——
  get yearRange(): number[] {
    return Array.from({ length: 12 }, (_, i) => this.yearRangeStart + i);
  }

  get calendarDays(): CalDay[] {
    const year = this.calYear;
    const month = this.calMonth;
    const today = this.parseDay(new Date())!;
    const first = new Date(year, month, 1);
    let startPad = first.getDay() - 1;
    if (startPad < 0) startPad = 6;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const monthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;

    const byDay = new Map<string, Intervento[]>();
    for (const i of this.interventi) {
      const key = String(i.data_ora || '').slice(0, 10);
      if (!key.startsWith(monthPrefix)) continue;
      const list = byDay.get(key) || [];
      list.push(i);
      byDay.set(key, list);
    }

    const scadByDay = new Map<string, ImpiantoVerifica[]>();
    for (const imp of this.impianti) {
      const key = String(imp.prossima_scadenza || '').slice(0, 10);
      if (!key.startsWith(monthPrefix)) continue;
      const list = scadByDay.get(key) || [];
      list.push(imp);
      scadByDay.set(key, list);
    }

    const days: CalDay[] = [];
    for (let i = 0; i < startPad; i++) {
      days.push({ date: null, dayNum: 0, isToday: false, isCurrentMonth: false, events: [], scadenze: [], chips: [] });
    }
    for (let d = 1; d <= daysInMonth; d++) {
      const date = `${monthPrefix}-${String(d).padStart(2, '0')}`;
      const isToday = today.getFullYear() === year && today.getMonth() === month && today.getDate() === d;
      const events = byDay.get(date) || [];
      const scadenze = scadByDay.get(date) || [];
      days.push({
        date,
        dayNum: d,
        isToday,
        isCurrentMonth: true,
        events,
        scadenze,
        chips: [
          ...events.map(item => ({ kind: 'intervento' as const, item })),
          ...scadenze.map(item => ({ kind: 'scadenza' as const, item })),
        ],
      });
    }
    while (days.length % 7 !== 0) {
      days.push({ date: null, dayNum: 0, isToday: false, isCurrentMonth: false, events: [], scadenze: [], chips: [] });
    }
    return days;
  }

  get dayInterventi(): Intervento[] {
    if (!this.calendarioDayFilter) return [];
    return this.interventi.filter(i => String(i.data_ora || '').slice(0, 10) === this.calendarioDayFilter);
  }

  get dayScadenzeImpianto(): ImpiantoVerifica[] {
    if (!this.calendarioDayFilter) return [];
    return this.impianti.filter(i => String(i.prossima_scadenza || '').slice(0, 10) === this.calendarioDayFilter);
  }

  togglePicker(mode: 'month' | 'year') {
    this.pickerMode = this.pickerMode === mode ? 'calendar' : mode;
    if (mode === 'year') this.yearRangeStart = this.calYear - 4;
  }

  selectMonth(month: number) {
    this.calMonth = month;
    this.pickerMode = 'calendar';
    this.loadCalMonth();
  }

  selectYear(year: number) {
    this.calYear = year;
    this.pickerMode = 'calendar';
    this.loadCalMonth();
  }

  navigatePrevYear() { this.yearRangeStart -= 12; }
  navigateNextYear() { this.yearRangeStart += 12; }

  prevMonth() {
    if (this.pickerMode !== 'calendar') return;
    if (this.calMonth === 0) { this.calMonth = 11; this.calYear--; }
    else this.calMonth--;
    this.loadCalMonth();
  }

  nextMonth() {
    if (this.pickerMode !== 'calendar') return;
    if (this.calMonth === 11) { this.calMonth = 0; this.calYear++; }
    else this.calMonth++;
    this.loadCalMonth();
  }

  loadCalMonth() {
    const dal = `${this.calYear}-${String(this.calMonth + 1).padStart(2, '0')}-01`;
    const last = new Date(this.calYear, this.calMonth + 1, 0).getDate();
    const al = `${this.calYear}-${String(this.calMonth + 1).padStart(2, '0')}-${String(last).padStart(2, '0')} 23:59:59`;
    this.apiService.getInterventi(dal, al).subscribe({
      next: (data) => this.interventi = data || [],
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore')
    });
    this.apiService.getImpianti().subscribe({
      next: (data) => this.impianti = data || [],
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore')
    });
  }

  selectCalDay(date: string | null) {
    if (!date) return;
    this.calendarioDayFilter = this.calendarioDayFilter === date ? null : date;
  }

  clearDayFilter() { this.calendarioDayFilter = null; }

  calEventClass(i: Intervento): string {
    const level = i.criticita || 'wait';
    if (level === 'crit') return 'cal-ev crit';
    if (level === 'warn') return 'cal-ev warn';
    if (level === 'ok') return 'cal-ev ok';
    return 'cal-ev wait';
  }

  calEventLabel(i: Intervento): string {
    const name = (i.fornitore || i.titolo || '').trim();
    const parts = name.split(/\s+/);
    if (parts.length >= 2) return `${parts[0]} ${parts[1][0]}.`;
    return name.slice(0, 18);
  }

  calScadenzaClass(imp: ImpiantoVerifica): string {
    const status = imp.stato_display || this.impiantoStatusLabel(imp);
    if (status === 'Scaduta') return 'cal-ev scadenza crit';
    if (status === 'In scadenza') return 'cal-ev scadenza warn';
    return 'cal-ev scadenza';
  }

  calScadenzaLabel(imp: ImpiantoVerifica): string {
    const name = (imp.nome || '').trim();
    return name.slice(0, 18) || 'Scadenza';
  }

  // —— Interventi ——
  openNuovoIntervento(impianto?: ImpiantoVerifica) {
    this.interventoEdit = undefined;
    this.formIntervento.reset({
      tipo: 'verifica', n_lavoratori: 0, criticita: 'wait',
      stato_doc: 'wait', stato_op: 'wait', stato_pers: 'wait', ricorrente: false, ricorrenza: null,
      esito: null, prossima_scadenza: null, id_impianto: null, id_fornitore: null, titolo: null,
    });
    if (impianto) {
      this.formIntervento.patchValue({
        id_impianto: impianto.id,
        titolo: impianto.nome,
        id_fornitore: impianto.id_fornitore || null,
      });
    }
    this.interventoDialog = true;
  }

  openEditIntervento(i: Intervento) {
    this.interventoEdit = i;
    this.formIntervento.patchValue({
      titolo: i.titolo,
      id_fornitore: i.id_fornitore,
      id_impianto: i.id_impianto || null,
      tipo: i.tipo,
      data_ora: i.data_ora ? new Date(i.data_ora) : null,
      ricorrente: !!(i.ricorrente === true || i.ricorrente === 1),
      ricorrenza: i.ricorrenza || null,
      durata_ore: i.durata_ore,
      n_lavoratori: i.n_lavoratori,
      note_interne: i.note_interne,
      esito: i.esito || null,
      prossima_scadenza: this.parseDay(i.prossima_scadenza),
      criticita: i.criticita,
      stato_doc: i.stato_doc,
      stato_op: i.stato_op,
      stato_pers: i.stato_pers,
    });
    this.interventoDialog = true;
  }

  saveIntervento() {
    if (this.formIntervento.invalid) return;
    const v = this.formIntervento.value;
    const form = new FormData();
    form.append('titolo', v.titolo);
    if (v.id_fornitore) form.append('id_fornitore', String(v.id_fornitore));
    if (v.id_impianto) form.append('id_impianto', String(v.id_impianto));
    form.append('tipo', v.tipo);
    const dataOra = v.data_ora instanceof Date
      ? `${this.toISODate(v.data_ora)} ${String(v.data_ora.getHours()).padStart(2, '0')}:${String(v.data_ora.getMinutes()).padStart(2, '0')}:00`
      : v.data_ora;
    form.append('data_ora', dataOra);
    form.append('ricorrente', v.ricorrente ? '1' : '0');
    if (v.ricorrente && v.ricorrenza) form.append('ricorrenza', v.ricorrenza);
    if (v.durata_ore != null) form.append('durata_ore', String(v.durata_ore));
    form.append('n_lavoratori', String(v.n_lavoratori || 0));
    if (v.note_interne) form.append('note_interne', v.note_interne);
    if (v.esito) form.append('esito', v.esito);
    const nextScad = this.formatFormDate(v.prossima_scadenza);
    if (nextScad) form.append('prossima_scadenza', nextScad);
    form.append('criticita', v.criticita || 'wait');
    form.append('stato_doc', v.stato_doc || 'wait');
    form.append('stato_op', v.stato_op || 'wait');
    form.append('stato_pers', v.stato_pers || 'wait');
    if (v.ordine_lavoro) form.append('ordine_lavoro', v.ordine_lavoro);
    if (v.preventivo) form.append('preventivo', v.preventivo);
    if (this.interventoEdit?.ordine_lavoro) form.append('ordine_lavoro_attuale', this.interventoEdit.ordine_lavoro);
    if (this.interventoEdit?.preventivo) form.append('preventivo_attuale', this.interventoEdit.preventivo);

    const req = this.interventoEdit
      ? this.apiService.updateIntervento(form, this.interventoEdit.id)
      : this.apiService.addIntervento(form);

    req.subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
      complete: () => {
        this.interventoDialog = false;
        this.apiService.message('success', 'Successo', 'Intervento salvato');
        this.refreshInterventi();
        if (this.impiantoDetail?.id) this.loadInterventiImpianto(this.impiantoDetail.id);
      }
    });
  }

  deleteIntervento(event: Event, i: Intervento) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Eliminare l'intervento "${i.titolo}"?`,
      accept: () => {
        this.apiService.deleteIntervento(i.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
          complete: () => {
            this.confirmationService.close();
            this.apiService.message('success', 'Eliminazione', 'Intervento eliminato');
            this.refreshInterventi();
          }
        });
      },
      reject: () => this.confirmationService.close()
    });
  }

  // —— Impianti / verifiche ——
  checklistItems(imp: ImpiantoVerifica | undefined): string[] {
    const raw = (imp?.checklist || '').trim();
    if (!raw) {
      return [
        'Controllo funzionale e integrità dei componenti',
        'Registrazione dell\'esito e del tecnico responsabile',
        'Indicazione di prescrizioni, anomalie e tempi di risoluzione',
        'Verbale o certificato allegato all\'intervento',
      ];
    }
    return raw.split(/\n+/).map(s => s.replace(/^[-*•]\s*/, '').trim()).filter(Boolean);
  }

  docsLabelImpianto(imp: ImpiantoVerifica): string {
    if (imp.documento) return '1 allegato';
    if (imp.categoria === 'Da completare' || imp.stato === 'da_completare') return 'Scheda incompleta';
    return '0 documenti';
  }

  openNuovoImpianto() {
    this.impiantoEdit = undefined;
    this.formImpianto.reset({
      categoria: 'Da completare',
      periodicita: 'semestrale',
      stato: 'da_programmare',
      preavviso: '30_7',
      id_fornitore: null,
      incaricato: null,
      descrizione: null,
      checklist: null,
      note: null,
      ultimo_intervento: null,
      prossima_scadenza: null,
      documento: null,
    });
    this.impiantoDialog = true;
  }

  openEditImpianto(imp: ImpiantoVerifica) {
    this.impiantoEdit = imp;
    this.formImpianto.patchValue({
      nome: imp.nome,
      descrizione: imp.descrizione,
      categoria: imp.categoria || 'Da completare',
      periodicita: imp.periodicita || 'semestrale',
      id_fornitore: imp.id_fornitore || null,
      incaricato: imp.incaricato || null,
      stato: imp.stato || 'da_programmare',
      ultimo_intervento: this.parseDay(imp.ultimo_intervento),
      prossima_scadenza: this.parseDay(imp.prossima_scadenza),
      preavviso: imp.preavviso || '30_7',
      checklist: imp.checklist || null,
      note: imp.note || null,
      documento: null,
    });
    this.impiantoDialog = true;
  }

  openDettaglioImpianto(imp: ImpiantoVerifica) {
    this.impiantoDetail = imp;
    this.impiantoDetailDialog = true;
    this.loadInterventiImpianto(imp.id);
  }

  loadInterventiImpianto(id: number) {
    this.interventiImpianto = this.interventi
      .filter(i => i.id_impianto === id)
      .sort((a, b) => String(b.data_ora || '').localeCompare(String(a.data_ora || '')))
      .slice(0, 8);
  }

  saveImpianto() {
    if (this.formImpianto.invalid) return;
    const v = this.formImpianto.value;
    const form = new FormData();
    form.append('nome', v.nome);
    if (v.descrizione) form.append('descrizione', v.descrizione);
    form.append('categoria', v.categoria || 'Da completare');
    form.append('periodicita', v.periodicita || 'da_definire');
    if (v.id_fornitore) form.append('id_fornitore', String(v.id_fornitore));
    if (v.incaricato) form.append('incaricato', v.incaricato);
    form.append('stato', v.stato || 'da_programmare');
    const ultimo = this.formatFormDate(v.ultimo_intervento);
    if (ultimo) form.append('ultimo_intervento', ultimo);
    const next = this.formatFormDate(v.prossima_scadenza);
    if (next) form.append('prossima_scadenza', next);
    if (v.preavviso) form.append('preavviso', v.preavviso);
    if (v.checklist) form.append('checklist', v.checklist);
    if (v.note) form.append('note', v.note);
    if (v.documento) form.append('documento', v.documento);
    if (this.impiantoEdit?.documento) form.append('documento_attuale', this.impiantoEdit.documento);

    const req = this.impiantoEdit
      ? this.apiService.updateImpianto(form, this.impiantoEdit.id)
      : this.apiService.addImpianto(form);

    req.subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
      complete: () => {
        this.impiantoDialog = false;
        this.apiService.message('success', 'Successo', 'Verifica salvata');
        this.apiService.getImpianti().subscribe({
          next: (d) => {
            this.impianti = d || [];
            if (this.impiantoDetail?.id) {
              const updated = this.impianti.find(x => x.id === this.impiantoDetail!.id);
              if (updated) this.impiantoDetail = updated;
            }
          }
        });
      }
    });
  }

  deleteImpianto(event: Event, imp: ImpiantoVerifica) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Eliminare la verifica "${imp.nome}"?`,
      accept: () => {
        this.apiService.deleteImpianto(imp.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
          complete: () => {
            this.confirmationService.close();
            this.impiantoDetailDialog = false;
            this.apiService.message('success', 'Eliminazione', 'Verifica eliminata');
            this.apiService.getImpianti().subscribe({ next: (d) => this.impianti = d || [] });
          }
        });
      },
      reject: () => this.confirmationService.close()
    });
  }

  // —— Rubrica ——
  openNuovaRubrica(tipo: 'compagnia' | 'ditta' = 'ditta') {
    this.rubricaEdit = undefined;
    this.formRubrica.reset({ tipo, abituale: false, stato_accreditamento: 'da_completare' });
    this.rubricaDialog = true;
  }

  openEditRubrica(a: AnagraficaRubrica) {
    this.rubricaEdit = a;
    this.formRubrica.patchValue({
      tipo: a.tipo || 'compagnia',
      ragione_sociale: a.ragione_sociale,
      piva: a.piva,
      sede: a.sede,
      referente: a.referente,
      email: a.email,
      telefono: a.telefono,
      abituale: !!a.abituale,
      note: a.note,
      specializzazione: a.specializzazione,
      stato_accreditamento: a.stato_accreditamento || 'da_completare',
      visura_scadenza: this.parseDay(a.visura_scadenza),
      polizza_scadenza: this.parseDay(a.polizza_scadenza),
      durc_scadenza: this.parseDay(a.durc_scadenza),
      abilitazioni_scadenza: this.parseDay(a.abilitazioni_scadenza),
      dvr_scadenza: this.parseDay(a.dvr_scadenza),
      preventivo_contratto_scadenza: this.parseDay(a.preventivo_contratto_scadenza),
      foglio_intervento_scadenza: this.parseDay(a.foglio_intervento_scadenza),
      scheda_manutenzione_scadenza: this.parseDay(a.scheda_manutenzione_scadenza),
    });
    this.rubricaDialog = true;
  }

  dateInputValue(v: string | Date | null | undefined): string | null {
    const d = this.parseDay(v);
    return d ? this.toISODate(d) : null;
  }

  /** Serializza date da p-calendar / stringhe native verso YYYY-MM-DD. */
  formatFormDate(v: string | Date | null | undefined): string | null {
    if (!v) return null;
    if (v instanceof Date) return this.toISODate(v);
    return String(v).slice(0, 10);
  }

  fileName(a: AnagraficaRubrica | undefined, key: RubricaDocKey): string {
    return ((a as any)?.[key] || '').toString();
  }

  docScadenzaLevel(a: AnagraficaRubrica): 'ok' | 'warn' | 'crit' | 'na' {
    const today = this.parseDay(new Date())!;
    const limit = new Date(today);
    limit.setDate(limit.getDate() + 30);
    let worst: 'ok' | 'warn' | 'crit' | 'na' = 'na';
    for (const d of this.rubricaDocs) {
      const day = this.parseDay((a as any)[d.scad]);
      if (!day) continue;
      if (day < today) return 'crit';
      if (day <= limit) worst = 'warn';
      else if (worst === 'na') worst = 'ok';
    }
    return worst;
  }

  saveRubrica() {
    if (this.formRubrica.invalid) return;
    const v = this.formRubrica.value;
    const form = new FormData();
    form.append('tipo', v.tipo || 'ditta');
    form.append('ragione_sociale', v.ragione_sociale);
    if (v.piva) form.append('piva', v.piva);
    if (v.sede) form.append('sede', v.sede);
    if (v.referente) form.append('referente', v.referente);
    if (v.email) form.append('email', v.email);
    if (v.telefono) form.append('telefono', v.telefono);
    form.append('abituale', v.abituale ? '1' : '0');
    if (v.note) form.append('note', v.note);
    if (v.specializzazione) form.append('specializzazione', v.specializzazione);
    form.append('stato_accreditamento', v.stato_accreditamento || 'da_completare');
    for (const d of this.rubricaDocs) {
      const scad = this.formatFormDate(v[d.scad]);
      if (scad) form.append(d.scad, scad);
      if (v[d.key]) form.append(d.key, v[d.key]);
      const actual = this.fileName(this.rubricaEdit, d.key);
      if (actual) form.append(`${d.key}_attuale`, actual);
    }
    if (this.rubricaEdit?.pos) form.append('pos_attuale', this.rubricaEdit.pos);

    const req = this.rubricaEdit
      ? this.apiService.updateRubrica(form, this.rubricaEdit.id)
      : this.apiService.addRubrica(form);

    req.subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
      complete: () => {
        this.rubricaDialog = false;
        this.apiService.message('success', 'Successo', 'Anagrafica salvata');
        this.apiService.getRubrica().subscribe({ next: (d) => { this.rubrica = d || []; this.rubricaDitte = this.rubrica.filter(r => r.tipo === 'ditta'); } });
      }
    });
  }

  deleteRubrica(event: Event, a: AnagraficaRubrica) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Eliminare "${a.ragione_sociale}" dalla rubrica?`,
      accept: () => {
        this.apiService.deleteRubrica(a.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
          complete: () => {
            this.confirmationService.close();
            this.apiService.message('success', 'Eliminazione', 'Anagrafica eliminata');
            this.apiService.getRubrica().subscribe({ next: (d) => { this.rubrica = d || []; this.rubricaDitte = this.rubrica.filter(r => r.tipo === 'ditta'); } });
          }
        });
      },
      reject: () => this.confirmationService.close()
    });
  }

  importRubrica() {
    this.apiService.importRubricaDaEventi().subscribe({
      next: (res) => this.apiService.message('success', 'Import', `Importate ${res.inserted}, saltate ${res.skipped}`),
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
      complete: () => this.apiService.getRubrica().subscribe({ next: (d) => { this.rubrica = d || []; this.rubricaDitte = this.rubrica.filter(r => r.tipo === 'ditta'); } })
    });
  }

  openCreaEvento(a: AnagraficaRubrica) {
    this.creaEventoRubrica = a;
    this.formCreaEvento.reset({
      evento: a.ragione_sociale,
      dal: null,
      al: null,
    });
    this.creaEventoDialog = true;
  }

  saveCreaEvento() {
    if (!this.creaEventoRubrica || this.formCreaEvento.invalid) return;
    const v = this.formCreaEvento.value;
    const dal = v.dal instanceof Date ? this.toISODate(v.dal) : String(v.dal).slice(0, 10);
    const al = v.al instanceof Date ? this.toISODate(v.al) : String(v.al).slice(0, 10);
    this.apiService.creaEventoDaRubrica(this.creaEventoRubrica.id, { evento: v.evento, dal, al }).subscribe({
      next: (res) => {
        this.creaEventoDialog = false;
        this.apiService.message('success', 'Evento', 'Bozza evento creata');
        if (res?.id) this.openEvento(res.id);
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
    });
  }

  // —— Documenti teatro ——
  onOpenDeleteDocumento(event: Event, documento: string) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento caricato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteConfigurazioneAccreditamenti(documento).subscribe({
          next: () => this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/backoffice/area-compagnie'])),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close();
            this.apiService.message('success', 'Eliminazione', 'Il documento è stato rimosso con successo!');
          },
        });
      },
    });
  }

  onDeleteDocumento(tipo: string) {
    if (tipo == 'scheda_tecnica') this.deleteSchedaTecnica.accept();
    else if (tipo == 'duvri') this.deleteDuvri.accept();
  }

  onCloseDeleteDocumento(tipo: string) {
    if (tipo == 'scheda_tecnica') this.deleteSchedaTecnica.reject();
    else if (tipo == 'duvri') this.deleteDuvri.reject();
  }

  onDocumento(documento: string) {
    const token = localStorage.getItem('teatro-colosseo-backoffice-auth-token') || '';
    const q = token ? `?type=documento&token=${encodeURIComponent(token)}` : '?type=documento';
    window.open(environment.apiURL + 'file/' + documento + q, '_blank');
  }

  onDocumenti() {
    const configurazione = new FormData();
    configurazione.append('scheda_tecnica', this.formDocumenti.get('scheda_tecnica')?.value || '');
    configurazione.append('duvri', this.formDocumenti.get('duvri')?.value || '');

    const req = JSON.stringify(this.configurazione) != '{}'
      ? this.apiService.updateConfigurazioneAccreditamenti(configurazione)
      : this.apiService.addConfigurazioneAccreditamenti(configurazione);

    req.subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.message('success', 'Successo', 'Dati salvati con successo!');
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/backoffice/area-compagnie']));
      },
    });
  }

  statusClass(level: StatusLevel | string): string {
    return `status-seg ${level || 'na'}`;
  }

  isRicorrente(i: Intervento): boolean {
    return !!(i.ricorrente === true || i.ricorrente === 1);
  }
}
